import { FC } from 'react'
import styles from 'components/features/coaching/advisorVideoCall/QualityIndicator/QualityIndicator.styl'
import cn from 'classnames'

export const QUALITY_INDICATOR_MAX_LEVEL = 7


type QualityIndicatorProps = {
  level: number
}
export const QualityIndicator: FC<QualityIndicatorProps> = (props) => {
  const { level } = props

  return (
    <div className={ styles.qualityIndicator }>
      <div className={ cn(styles.level, level >= QUALITY_INDICATOR_MAX_LEVEL && styles.activeLevel) } />
      <div className={ cn(styles.level, level >= 6 && styles.activeLevel) } />
      <div className={ cn(styles.level, level >= 5 && styles.activeLevel) } />
      <div className={ cn(styles.level, level >= 4 && styles.activeLevel) } />
      <div className={ cn(styles.level, level >= 3 && styles.activeLevel) } />
      <div className={ cn(styles.level, level >= 2 && styles.activeLevel) } />
      <div className={ cn(styles.level, level >= 1 && styles.activeLevel) } />
    </div>
  )
}


